export default function pretty (input) {
  return JSON.stringify(input, null, 2);
}


// WEBPACK FOOTER //
// ./src/util/pretty.js